import { createSlice } from "@reduxjs/toolkit";
import {
  listReferenceChecks,
  createReferenceCheck,
} from "../actions/reference-check-actions";

const initialState = {
  byCandidateId: {},
  loadingByCandidateId: {},
  error: null,
};

const referenceCheckSlice = createSlice({
  name: "referenceCheck",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listReferenceChecks.pending, (state, action) => {
        state.loadingByCandidateId[action.meta.arg.candidateId] = true;
      })
      .addCase(listReferenceChecks.fulfilled, (state, action) => {
        const { candidateId, items } = action.payload;
        state.loadingByCandidateId[candidateId] = false;
        state.byCandidateId[candidateId] = items;
      })
      .addCase(listReferenceChecks.rejected, (state, action) => {
        state.loadingByCandidateId[action.meta.arg.candidateId] = false;
        state.error = action.payload;
      })
      .addCase(createReferenceCheck.fulfilled, (state, action) => {
        const { candidateId, item } = action.payload;
        const list = state.byCandidateId[candidateId] || [];
        state.byCandidateId[candidateId] = [item, ...list];
      });
  },
});

const referenceCheckSliceReducer = referenceCheckSlice.reducer;
export default referenceCheckSliceReducer;
